export default __webpack_public_path__ + "e76fcff3381ee7ef7e30ed580406270c.png";